import { USER_ACTION as types } from '../../constants/user';

const initialState = {
  userInfo: {},
  preference: {},
  watchlist: {
    preDefined: [],
    custom: [],
  }
}

export const userReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_USER_INFO:
      return Object.assign({}, state, {
        userInfo: action.userInfo || state.userInfo
      });
    case types.SET_PREFERENCE:
      return Object.assign({}, state, {
        preference: action.preference || state.preference
      })
    case types.GET_WATCHLIST2:
      return Object.assign({}, state, {
        watchlist: action.watchlist || state.watchlist
      });
    default:
      return state
  }
}
